import usePageActivity from './use-page-activity';
import useSystemNotification from './use-system-notification';
import { useCallback, useEffect, useRef } from 'react';
import useUserConfig from './use-user-config';
import { i18n } from '@/i18n';

interface IThreadNotificationOptions {
  type: 'SUCCESS' | 'FAIL' | 'CONFIRM';
  title?: string;
}
// 通知状态映射表
const NOTIFICATION_CONFIG = {
  SUCCESS: {
    icon: '/thread-notifiaction/success.svg',
    title: i18n.t('thread:systemNotification.taskNotification'),
  },
  FAIL: {
    icon: '/thread-notifiaction/error.svg',
    title: i18n.t('thread:systemNotification.executionFailed'),
  },
  CONFIRM: {
    icon: '/thread-notifiaction/confirm.svg',
    title: i18n.t('thread:systemNotification.waitingReply'),
  },
};

const useThreadSystemNotification = () => {
  const { userConfig, getUserConfig } = useUserConfig();
  const isPageActive = usePageActivity();
  // 使用 ref 存储最新的 isPageActive 值
  const isPageActiveRef = useRef(isPageActive);
  isPageActiveRef.current = isPageActive;

  // 使用通知 Hook
  const { sendNotification: _sendNotification } = useSystemNotification();

  // 处理通知函数
  const sendNotification = useCallback(
    (_options: IThreadNotificationOptions) => {
      if (!userConfig?.thread_notification) {
        return;
      }

      if (isPageActiveRef.current) {
        return;
      }

      const options = NOTIFICATION_CONFIG[_options.type];
      if (_options.title) {
        options.title = i18n.t('thread:systemNotification.taskPrefix', {
          title: _options.title,
        });
      }

      _sendNotification(options);
    },
    [_sendNotification, userConfig?.thread_notification],
  );

  useEffect(() => {
    getUserConfig(['thread_notification']);
  }, []);

  return {
    sendNotification,
  };
};

export default useThreadSystemNotification;
